import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { cx } from 'class-variance-authority'
import Paragraph, { ParagraphProps } from '@/shared/v2/shared/components/Paragraph'
import { forwardRef } from 'react'

const RadioGroupRoot = RadioGroupPrimitive.Root
const RadioGroupIndicator = RadioGroupPrimitive.Indicator

type RadioGroupItemProps = {
    value: string
    label: string
}

const RadioGroupItem = ({ value, label, ...rest }: RadioGroupItemProps) => (
    <div className="flex items-center gap-2 cursor-pointer select-none" {...rest}>
        <RadioGroupPrimitive.Item
            className={cx(
                'size-[16px] rounded-full border border-borderSecondary outline-none',
                'data-[state=checked]:border-borderPositiveSubdued',
                'hover:border-borderPositiveSubdued',
                'transition-colors duration-200'
            )}
            value={value}
            id={value}
            data-testid={`__export-data-dialog-radio-${value}__`}
        >
            <RadioGroupIndicator className="relative flex size-full items-center justify-center after:block after:size-[8px] after:rounded-full after:bg-backgroundPositiveStrong" />
        </RadioGroupPrimitive.Item>
        <label className="text-sm leading-4 text-textPrimary cursor-pointer w-full" htmlFor={value}>
            {label}
        </label>
    </div>
)

type RadioGroupLabelProps = ParagraphProps

const RadioGroupLabel = forwardRef<HTMLParagraphElement, RadioGroupLabelProps>(
    ({ id, className, children, ...props }, ref) => (
        <Paragraph id={id} ref={ref} variant="medium" className={cx('pb-1', className)} {...props}>
            {children}
        </Paragraph>
    )
)

export { RadioGroupRoot, RadioGroupIndicator, RadioGroupItem, RadioGroupLabel }
